module.exports = __webpack_public_path__ + "img/a4-عمودی.a7fd28a9.jpg";